// extracted by mini-css-extract-plugin
module.exports = {"secondaryBtn":"style_secondaryBtn__1l629","two":"style_two__qZ72I","one":"style_one__kSEI0","three":"style_three__k6pwA"};